import React, { Fragment, useLayoutEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies -- DLS Icons is a part of the DLS React package
import { IconClose } from '@americanexpress/dls-icons';
import { Button } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { connectAsync } from 'iguazu';

const PopupHeader = ({
  children, loadStatus, router,
}) => {
  // istanbul ignore next -- This effect is only for styling purposes and does not affect functionality.
  useLayoutEffect(() => {
    if (loadStatus.all === 'complete') {
      document.body.classList.add('dls-white-bg');
    }
  }, [loadStatus.all]);

  const handleClose = () => {
    window.top.postMessage(
      {
        messageId: 'CLOSE_SESSION_FRAME',
        status: 101,
      },
      '*'
    );
  };

  const showHideTitle = () => {
    if (router.params.locale === 'en-us' && router.location.query.module === 'identity-ui-authentication') {
      return children;
    }
    return (
      <Fragment>
        <header
          className="border-b flex flex-align-content-center flex-justify-center dls-white-bg"
          style={{ minHeight: '60px' }}
        >
          <span className="dls-logo-line-sm flex-align-self-center">
            <img
              src="https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.24.1/package/dist/img/logos/dls-logo-line.svg"
              alt="American Express"
            />
          </span>
          <Button
            className="position-absolute flex-align-self-center"
            data-testid="close-button"
            style={{ right: '10px' }}
            onClick={handleClose}
          >
            <IconClose
              style={{ fill: '#006FCF' }}
              filled="brand"
              size="md"
              isFilled={true}
              title="close button"
              titleId="iframe-close-icon"
            />
          </Button>
        </header>
        { children }
      </Fragment>
    );
  };

  return (
    loadStatus.all === 'loading'
      ? null
      : showHideTitle()

  );
};

PopupHeader.propTypes = {
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }),
  children: PropTypes.node.isRequired,
  router: PropTypes.shape({
    params: PropTypes.shape({
      locale: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.shape({
        module: PropTypes.string,
      }),
    }),
  }),
};

// istanbul ignore next -- This effect is only for styling purposes and does not affect functionality.
const loadDataAsProps = ({ ownProps: { router } }) => ({
  router: () => ({ status: 'complete', data: router }),
});

export default connectAsync({ loadDataAsProps })(PopupHeader);
